import React, { useRef, useState } from "react";
import * as lamejs from "@breezystack/lamejs";
import {
  getStorage,
  ref as firebaseRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import "./css/Sellbeat.css";
import client from "./appwriteConfig";
import { Client, Databases, Storage, ID } from "appwrite";
import { app } from "./firebaseConfig"; // Ensure you have this file with your Firebase config
import { useUser } from "./UserContext";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import genres from "./genreBeat";
import { encodeAudioBufferToMp3 } from "./convertToMp3";
function SellBeat() {
  const { user } = useUser();
  const [mp3File, setMp3File] = useState(null);
  const [beatName, setBeatName] = useState("");
  const [originalMp3Url, setOriginalMp3Url] = useState("");
  const [convertedMp3Url, setConvertedMp3Url] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [artistName, setArtistName] = useState("");
  const [genre, setGenre] = useState("");
  const [bpm, setBpm] = useState("");
  const [cost, setCost] = useState("");
  const [basicCost, setBasicCost] = useState("");
  const [premiumCost, setPremiumCost] = useState("");
  const storage = getStorage(app);
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();
  const [stems, setStems] = useState([{ name: "", file: null }]);

  const [selectedGenres, setSelectedGenres] = useState([]);

  const genreOptions = genres.map((genre) => ({ value: genre, label: genre }));
  const handleGenreChange = (selectedOptions) => {
    setSelectedGenres(selectedOptions.map((option) => option.value));
  };
  const handleAudioChange = (event) => {
    setMp3File(event.target.files[0]);
  };

  const handleImageChange = (event) => {
    setImageFile(event.target.files[0]);
  };

  const uploadFile = async (fileBlob, filePath) => {
    const fileRef = firebaseRef(storage, filePath);
    await uploadBytes(fileRef, fileBlob);
    return getDownloadURL(fileRef);
  };
  const capitalizeFirstLetterOfEachWord = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const UploadSellBeatData = async () => {
    if (!mp3File || !imageFile) return;
    setLoading(true);
    setError(null);
    try {
      const genreString = selectedGenres.join(", ");
      const capitalizedBeatName = capitalizeFirstLetterOfEachWord(beatName);
      const capitalizedArtistName = capitalizeFirstLetterOfEachWord(artistName);
      const audioFileType = mp3File.name.split(".").pop();
      const audioFileName = `${capitalizedBeatName}.${audioFileType}`;
      // Original MP3 upload and URL setting
      const originalAudioPath = `beats/${user.email}/${capitalizedArtistName}/${capitalizedBeatName}/${audioFileName}`;
      const originalUrl = await uploadFile(mp3File, originalAudioPath);
      setOriginalMp3Url(originalUrl);

      const reader = new FileReader();
      reader.onload = async (e) => {
        const arrayBuffer = e.target.result;
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        if (audioBuffer.numberOfChannels !== 2) {
          alert("The file must be a stereo audio file.");
          return;
        }

        const mp3Blob = await encodeAudioBufferToMp3(audioBuffer, 64); // Convert at 64 kbps
        const convertedAudioPath = `beats/${user.email}/${capitalizedArtistName}/${capitalizedBeatName}/low__${capitalizedBeatName}.mp3`;
        const convertedUrl = await uploadFile(mp3Blob, convertedAudioPath);
        setConvertedMp3Url(convertedUrl);

        const imageFileType = imageFile.name.split(".").pop();
        const imageFileName = `${capitalizedBeatName}.${imageFileType}`;
        const imagePath = `beats/${user.email}/${capitalizedArtistName}/${capitalizedBeatName}/albumArt/${imageFileName}`;
        const uploadedImageUrl = await uploadFile(imageFile, imagePath);
        setImageUrl(uploadedImageUrl);

        const uploadedStems = [];

        for (const stem of stems) {
          if (stem.file && stem.name.trim()) {
            const stemFileType = stem.file.name.split(".").pop();
            const stemFileName = `${stem.name
              .trim()
              .replace(/\s+/g, "_")}.${stemFileType}`;
            const stemPath = `beats/${user.email}/${capitalizedArtistName}/${capitalizedBeatName}/stems/${capitalizedBeatName}_${stemFileName}`;

            const stemUrl = await uploadFile(stem.file, stemPath);

            uploadedStems.push({
              name: stem.name.trim(),
              url: stemUrl,
              path: stemPath,
            });
          }
        }

        const productData = {
          artistName: capitalizedArtistName,
          beatName: capitalizedBeatName,
          genre: genreString,
          bpm: parseInt(bpm, 10),
          basicCost: parseInt(basicCost, 10),
          premiumCost: parseInt(premiumCost, 10),
          cost: parseInt(cost, 10),
          audioUrl: originalUrl,
          lowAudioUrl: convertedUrl,
          email: user.email,
          imageUrl: uploadedImageUrl,
          audioPath: originalAudioPath,
          lowAudioPath: convertedAudioPath,
          imagePath,
          stems: JSON.stringify(uploadedStems),
        };

        const database = new Databases(client);
        await database.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          process.env.REACT_APP_COLLECTION_BEATS_ID,
          ID.unique(),
          productData
        );
        setLoading(false);
        navigate("/beats");
      };
      reader.readAsArrayBuffer(mp3File);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#333",
      borderColor: state.isFocused ? "#666" : "#444",
      boxShadow: state.isFocused ? "0 0 0 1px #266" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#169" : "#555",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#222",
      color: "white",
      border: "1px solid #555",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555"
        : state.isFocused
        ? "#333"
        : "transparent",
      color: "white",
      "&:hover": {
        backgroundColor: "#555",
        color: "white",
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: "#555",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: "white",
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      color: "#999",
      "&:hover": {
        backgroundColor: "#777",
        color: "white",
      },
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "white",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "white",
    }),
  };

  return (
    <div className="sell-beats-container">
      <h2>Sell Your Beat</h2>
      <div className="form-group">
        <label>Artist Name:</label>
        <input
          type="text"
          value={artistName}
          onChange={(e) => setArtistName(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label>Beat Name:</label>
        <input
          type="text"
          value={beatName}
          onChange={(e) => setBeatName(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label>Genres:</label>
        <Select
          options={genreOptions}
          isMulti
          closeMenuOnSelect={false}
          onChange={handleGenreChange} // Updated function reference
          value={genreOptions.filter((option) =>
            selectedGenres.includes(option.value)
          )}
          placeholder="Select Genres"
          classNamePrefix="filter-dropdown" // Optional for custom styling
          styles={customStyles}
        />
      </div>
      <div className="form-group">
        <label>Tempo:</label>
        <input
          type="number"
          value={bpm}
          onChange={(e) => setBpm(parseInt(e.target.value, 10) || 0)}
          required
          min="0"
        />
      </div>
      <div className="form-group">
        <label>Basic Cost (WAV/MP3):</label>
        <input
          type="number"
          value={basicCost}
          onChange={(e) => setBasicCost(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label>Upload Audio File:</label>
        <input
          type="file"
          accept="audio/mpeg, audio/wav"
          onChange={handleAudioChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Upload Image File:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Upload Stems (Optional):</label>
        {stems.map((stem, index) => (
          <div key={index} style={{ marginBottom: "12px" }}>
            <input
              type="text"
              placeholder="Stem Name (e.g. Kick, Bass)"
              value={stem.name}
              onChange={(e) => {
                const newStems = [...stems];
                newStems[index].name = e.target.value;
                setStems(newStems);
              }}
              style={{ marginRight: "10px", width: "160px" }}
            />
            <input
              type="file"
              accept="audio/wav, audio/mp3"
              onChange={(e) => {
                const newStems = [...stems];
                newStems[index].file = e.target.files[0];
                setStems(newStems);
              }}
            />
          </div>
        ))}
        <button
          type="button"
          onClick={() => setStems([...stems, { name: "", file: null }])}
          className="add-stem-btn"
        >
          + Add Another Stem
        </button>
        {stems.some((stem) => stem.name.trim() && stem.file) && (
          <div className="form-group">
            <label>Premium Cost (WAV + Stems):</label>
            <input
              type="number"
              value={premiumCost}
              onChange={(e) => setPremiumCost(e.target.value)}
              required
            />
          </div>
        )}
      </div>

      <button className="onSubmitButton" onClick={UploadSellBeatData}>
        {" "}
        {loading ? (
          <>
            Uploading...
            <ClipLoader color="#ffffff" loading={loading} size={20} />{" "}
          </>
        ) : (
          "Submit"
        )}
      </button>
      {error && <div className="error-message">{error}</div>}

      {/* {originalMp3Url && (
        <div>
          <h2>Original MP3:</h2>
          <audio controls src={originalMp3Url}>
            Your browser does not support the audio tag.
          </audio>
          <a href={originalMp3Url} download="original_audio.mp3">
            Download Original MP3
          </a>
        </div>
      )}
      {convertedMp3Url && (
        <div>
          <h2>Converted MP3:</h2>
          <audio controls src={convertedMp3Url}>
            Your browser does not support the audio tag.
          </audio>
          <a href={convertedMp3Url} download="converted_audio.mp3">
            Download Converted MP3
          </a>
        </div>
      )}{" "}
      {imageUrl && (
        <div>
          <h2>Uploaded Image:</h2>
          <img src={imageUrl} alt="Uploaded" style={{ width: "300px" }} />
        </div>
      )} */}
    </div>
  );
}

export default SellBeat;
